import { PropsWithChildren } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { DEFAULT_QUERY_PROPS } from '@xemplo/query-helpers';

import { useQueryClientErrorHandlers } from './use-query-client-error-handlers';

export function QueryClientDefaults({ children }: PropsWithChildren) {
  useQueryClientDefaults();
  return children;
}

export function useQueryClientDefaults() {
  const queryClient = useQueryClient();
  const { throwOnError, onError } = useQueryClientErrorHandlers();

  queryClient.setDefaultOptions({
    queries: { ...DEFAULT_QUERY_PROPS, throwOnError },
    mutations: { onError },
  });
}
